module.exports = __webpack_public_path__ + "static/media/color.d2f9ef7a.png";